const { MarkerClusterer } = require('@googlemaps/markerclusterer');

$(window).one('maps_loaded', function () {
  const logtitudeInput = document.getElementById('logtitude-input');
  const latitudeInput = document.getElementById('latitude-input');
  const elem = $('#map.search')[0];
  if(!elem) {
    return;
  }
  const location = window?.locations?.[0];

  const zoomLevel = {
    country: 5,
    administrative_area_level_1: 7,
    locality: 10,
    street_address: 12,
    route: 12
  }

  const map = new google.maps.Map(elem, {
    center: { lat: +latitudeInput?.value || +location?.lat || 40.6869908, lng: +logtitudeInput?.value || +location?.lng || -74.1616497},
    zoom: zoomLevel[global.place_type] || 4,
    clickableIcons: false,
    options: {
      gestureHandling: 'greedy'
    }
  });

  class CustomMarker extends google.maps.Marker {
    constructor(options) {
      super(options)
    }

    getVisible() {
      return true;
    }
  }
  const markers = window.locations.map((listing) => {
    const marker = new CustomMarker({
      position: { lat: +listing.lat, lng: +listing.lng },
    });
    const infowindow = new google.maps.InfoWindow({
      content: `<p class="m-0" id="${listing.slug}">${listing.name}</p>`,
      disableAutoPan: true
    });
    infowindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
    google.maps.event.addListener(infowindow, 'domready', customizeInfoWindow);
    marker.setVisible(false)
    return marker;
  });
  new MarkerClusterer({ markers, map });

  global.map = map;
})

function customizeInfoWindow(e) {
  const iwOuter = $('.gm-style-iw');
  iwOuter.find(':nth-child(2)').remove();
  iwOuter.each(function () {
    $(this).off('click').on('click', function () {
      $('html').animate({
        scrollTop: $(`[data-id='${$(this).find('p').attr('id')}']`).offset().top - 120
      }, 200);
    });
  })
}